












import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'UserPrivacy'
})

export default class UserPrivacy extends Vue {

  created() {
    document.title = '用户隐私';
  }
}
